export default __webpack_public_path__ + "static/media/userafterclick.7cbc6ce9.svg";